function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFredHutch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36.93 36.93"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#feaa00",
  d: "M28.5 2.5q2 1 0 0",
  style: {
    opacity: 0.012
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005554",
  d: "M35.5 2.5q2 1 0 0",
  style: {
    opacity: 0.012
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0caecb",
  d: "M22.5 7.5q-1 0-1 1-3.864-.333-2.5-4 3.986-1.791 3.5 3",
  style: {
    opacity: 0.592
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233565",
  d: "M34.5 3.5h1q.5 1.5 2 2v1q-1.258.513-1 2a5.73 5.73 0 0 1-3 1z",
  style: {
    opacity: 0.854
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005554",
  d: "M37.5 4.5q2 1 0 0",
  style: {
    opacity: 0.012
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9b216",
  d: "m28.5 3.5 2 3q-1 0-1 1-1 0-1 1-1 0-1 1-1 0-1 1h-1l-1-4q1.143-2.643 4-3",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "navy",
  d: "M37.5 6.5q2 1 0 2z",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1e375e",
  d: "m34.5 3.5-1 6v1q-1 0-1 1-1 0-1 1h-1q-2-2.5 0-5v-1z",
  style: {
    opacity: 0.953
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdb60a",
  d: "m24.5 6.5 1 4v1q-1 0-1 1h-1q-1.65-1.657-2-4 1 0 1-1z",
  style: {
    opacity: 0.945
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00403f",
  d: "M36.5 8.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#203160",
  d: "M29.5 7.5h1q-2 2.5 0 5v1q-1 0-1 1-1 0-1 1-.9-2.1-3-3v-1q1 0 1-1 1 0 1-1 1 0 1-1 1 0 1-1",
  style: {
    opacity: 0.953
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 11.5q-1-2 0 0",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#feb809",
  d: "M8.5 14.5q-1 0-1 1h-3q-.576-3.248 2-5 2.417 1.23 2 4",
  style: {
    opacity: 0.709
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a955aa",
  d: "M37.5 11.5q2 1 0 0",
  style: {
    opacity: 0.012
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9dfa",
  d: "M2.5 11.5q1.647 1.65.5 4-2-2.067-.5-4",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b14cc6",
  d: "M33.5 10.5a5.73 5.73 0 0 1 3 1v4q-1.5.5-2 2-1 0-1 1h-1q.406-2.82-2-4v-1q1 0 1-1 1 0 1-1 1 0 1-1",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad4cc7",
  d: "M13.5 15.5q-1.812-1.1-4-1 1.468-2.468 4-4 3.844 2.753 0 5",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d74cdf",
  d: "M16.5 11.5q1.647 1.65.5 4a8.43 8.43 0 0 1-.5-4",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4e494e",
  d: "M23.5 12.5v1q-1 0-1 1-1.886-1.685 1-2",
  style: {
    opacity: 0.027
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1e3357",
  d: "M24.5 12.5h1q2.1.9 3 3v1h-1q-2.343-.35-4-2v-1q1 0 1-1",
  style: {
    opacity: 0.957
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b149cb",
  d: "M8.5 14.5h1q2.188-.1 4 1a303 303 0 0 1-3 4 6.54 6.54 0 0 0-3-3v-1q1 0 1-1",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d35ad2",
  d: "M37.5 15.5a2.43 2.43 0 0 1 .5-2q1.038 1.405-.5 2",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1e365e",
  d: "M22.5 14.5h1q1.657 1.65 4 2v1q-1 0-1 1-1 0-1 1h-4q-.2-2.687 1-5",
  style: {
    opacity: 0.723
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad4cc8",
  d: "M29.5 14.5h1q2.406 1.18 2 4-2.193 1.456-4-1v-2q1 0 1-1",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#be40bf",
  d: "M36.5 15.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#aa4cc5",
  d: "M7.5 16.5a6.54 6.54 0 0 1 3 3l-2 2q-1 0-1 1h-3q-.712-4.22 3-6",
  style: {
    opacity: 0.649
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#542b80",
  d: "M27.5 17.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.024
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00fffe",
  d: "M37.5 18.5q-1-2 0 0",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003266",
  d: "M26.5 18.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.02
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#22a3c1",
  d: "m34.5 17.5 2 1v4h-4v-4h1q1 0 1-1",
  style: {
    opacity: 0.702
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00aaa9",
  d: "M37.5 18.5q2 1 0 0",
  style: {
    opacity: 0.012
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6441ff",
  d: "M2.5 18.5q1.647 1.65.5 4-2-2.067-.5-4",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#32829f",
  d: "M21.5 19.5q1.602 1.402 4 1a26.3 26.3 0 0 1-5 2q0-2-2-2 .907-2.972 3-1",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00403f",
  d: "M25.5 19.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fe00ff",
  d: "M28.5 19.5q2 1 0 0",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00adcc",
  d: "M18.5 20.5q.5 1.5 2 2-.789 2.596-3 4-3 0-3-3 1.143-2.643 4-3",
  style: {
    opacity: 0.642
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#282f3f",
  d: "M30.5 20.5q1.538.595.5 2a2.43 2.43 0 0 1-.5-2",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2ea9ff",
  d: "M37.5 22.5a2.43 2.43 0 0 1 .5-2q1.038 1.405-.5 2",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00807f",
  d: "M36.5 22.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#188c95",
  d: "M36.5 23.5q-1.333 3.538-4 .5a8.43 8.43 0 0 1 4-.5",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b375b",
  d: "M8.5 21.5h1a19.2 19.2 0 0 1-1 6v1h-1q-1.593-2.4 0-5v-1q1 0 1-1",
  style: {
    opacity: 0.953
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b3a61",
  d: "M9.5 21.5q3 0 3 3-1 0-1 1-1 0-1 1-1 0-1 1h-1a19.2 19.2 0 0 0 1-6",
  style: {
    opacity: 0.942
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1d375f",
  d: "M7.5 23.5q-1.593 2.6 0 5v1h-3q-.712-4.22 3-6",
  style: {
    opacity: 0.634
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#24aecc",
  d: "M14.5 23.5q0 3 3 3l-1 2h-1q-1 0-1 1h-1q-.71-2.11-3-2v-1q1 0 1-1 1 0 1-1z",
  style: {
    opacity: 0.973
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b365e",
  d: "M29.5 28.5q-2.48-.24-4-2 1.602-1.402 4-1z",
  style: {
    opacity: 0.624
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15142e",
  d: "M2.5 25.5q1.647 1.65.5 4-2.652-1.773-.5-4",
  style: {
    opacity: 0.004
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0fafcc",
  d: "M9.5 27.5h1q2.29-.11 3 2v1q-1 0-1 1h-1l-2-3z",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1f3658",
  d: "M25.5 26.5q1.52 1.76 4 2v1q-1.5.5-2 2-1 0-1 1-1 0-1 1h-1q.329-1.762-1-3-1.148 1.668-3 2v-1q2-3 5-5",
  style: {
    opacity: 0.673
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#131396",
  d: "M30.5 29.5a8.43 8.43 0 0 1 .5-4q1.147 2.35-.5 4",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0cafd4",
  d: "M8.5 28.5h1l2 3v2h-1q-.5-1.5-2-2 0-1-1-1v-1q1 0 1-1",
  style: {
    opacity: 0.965
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003f80",
  d: "M29.5 29.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcb519",
  d: "M15.5 28.5h2l-5 6h-1v-2q1 0 1-1 1 0 1-1 1 0 1-1 1 0 1-1",
  style: {
    opacity: 0.965
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#febc01",
  d: "M17.5 28.5q2.11.71 2 3-1 0-1 1v1h-1q-2.317.305-4 2-.91-.186-1-1z",
  style: {
    opacity: 0.945
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#04b1cf",
  d: "M8.5 31.5q1.5.5 2 2-2.317.305-4 2-1.342-2.767 2-4",
  style: {
    opacity: 0.949
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#203461",
  d: "M19.5 31.5h1v1q-.11 2.29 2 3v1h-4v-4q1 0 1-1",
  style: {
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1c375e",
  d: "M24.5 33.5q-.5 1.5-2 2-2.11-.71-2-3 1.852-.332 3-2 1.329 1.238 1 3",
  style: {
    opacity: 0.933
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b8ba2",
  d: "M2.5 32.5q1.647 1.65.5 4-2.652-1.773-.5-4",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0fabc7",
  d: "M7.5 30.5q1 0 1 1-3.342 1.233-2 4 1.683-1.695 4-2l-2 3h-4q-.712-4.22 3-6",
  style: {
    opacity: 0.551
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8b64d7",
  d: "M30.5 36.5a8.43 8.43 0 0 1 .5-4q1.147 2.35-.5 4",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdb504",
  d: "m17.5 33.5-2 3q-2.975.514-4-2h1q.09.814 1 1 1.683-1.695 4-2",
  style: {
    opacity: 0.627
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a548c0",
  d: "M27.5 31.5q2.57 1.703 2 5h-4v-3q0-1 1-1c1 0 1-.333 1-1",
  style: {
    opacity: 0.114
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007fbf",
  d: "M8.5 36.5q2 1 0 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#febf00",
  d: "M15.5 36.5q2 1 0 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00403f",
  d: "M22.5 36.5q2 1 0 0",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7f0080",
  d: "M29.5 36.5h1q-.278 1.005-1 0",
  style: {
    opacity: 0.008
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00c7c7",
  d: "M8.5 37.5q-1.65 1.647-4 .5a8.43 8.43 0 0 1 4-.5",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc700",
  d: "M15.5 37.5q-1.65 1.647-4 .5a8.43 8.43 0 0 1 4-.5",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#113a77",
  d: "M22.5 37.5q-1.65 1.647-4 .5a8.43 8.43 0 0 1 4-.5",
  style: {
    opacity: 0.016
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ae4ab9",
  d: "M29.5 37.5q-1.65 1.647-4 .5a8.43 8.43 0 0 1 4-.5",
  style: {
    opacity: 0.016
  }
}));
export default SvgFredHutch;